module.exports = __webpack_public_path__ + "static/img/IMG_20240816_215308.a43ffa25.jpg";